import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../services/wrapper-http-service';
import { Observable, shareReplay } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  svgIconMap: Map<string, Observable<SafeHtml>> = new Map<string, Observable<SafeHtml>>();

  constructor(private http: WrapperHttpService, private sanitizer: DomSanitizer) {}

  getSvgIcon(svgPath: string): Observable<SafeHtml> {
    if (this.svgIconMap.has(svgPath)) {
      return this.svgIconMap.get(svgPath);
    }

    const svgIcon$ = this.http.get<string>(svgPath, { responseType: 'text' }).pipe(
      map((svg: string) => this.sanitizer.bypassSecurityTrustHtml(svg)),
      shareReplay(1),
    );

    this.svgIconMap.set(svgPath, svgIcon$);

    return svgIcon$;
  }
}
